export const loadContentSquare = () => {
    if (window._csq) return; // evita doppio caricamento

    window._csq = window._csq || [];

    const script = document.createElement("script");
    script.src = "https://t.contentsquare.net/uxa/91256b67addfe.js";
    script.async = true;
    script.type = "text/javascript";

    document.head.appendChild(script);
};
